import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getKiosksHowDev(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			desc: "Na úvod zhodnotíme vaši situaci, potřeby a zjistíme, kde a pro jaké účely chcete kiosek využívat. Také s vámi probereme, sp[[jestli potřebujete pouze aplikaci na míru, nebo i hardware.]]",
		},
		{
			desc: "sp[[Pustíme se do vývoje]] kioskové aplikace, případně do zajištění hardwaru pro kiosek.",
		},
		{
			desc: "Po dokončení vývoje sp[[software propojíme s kioskem]] a případně k němu přidáme další periferie (např. platební terminál).",
		},
		{
			desc: "sp[[Po předání kioskového řešení vás důkladně zaškolíme]] a budeme vám k ruce s případným dalším rozvojem aplikace.",
		},
	];
}
